import React, { Component } from 'react';


/**
* Class Status
* Generic component to generate status bar
**/
class Status extends Component {
  /**
  * props
  * parent : parent component
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.props.parent.status = this;
  }

  /**
  * render
  * Rendering component function : display the status bar
  **/
  render() {
    let status = <div id="status" />;

    if (this.props.type && this.props.message) {
      const classString = 'alert alert-' + this.props.type;
      status =
        <div id="status" className={classString} ref="status">
          {this.props.message}
        </div>;

      if(this.props.type === "danger" || this.props.type === "success") {
        this.setTimeout();
      }
    }

    return status;
  }

  /**
  * setTimeout
  * Creates a timeout to clear the status after a while
  **/
  setTimeout() {
    const thisRef = this;
    this.timeoutId = setTimeout(
      function() {
        if(thisRef.timeoutId !== undefined) {
          thisRef.timeoutId = undefined;
          thisRef.props.parent.setState({
            status: {
              type: "",
              message: ""
            }
          });
        }
      }, 3000
    );
  }

  /**
  * unsetTimeout
  * Clear the timeout
  **/
  unsetTimeout() {
    if(this.timeoutId !== undefined) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

}

export default Status;



// WEBPACK FOOTER //
// ./src/views/Helper/Status.js